export default {
	actionTitle: "Sign in to your account",
	googleSignInButton: "Sign in with Google",
	microsoftSignInButton: "Sign in with Microsoft",
	emailSignInButton: "Sign in with Email",
	DontHaveAccountText: "Don't yet have a Teaming account?",
	SignUpText: "Sign up.",
	infoTitle: "Welcome back, friend. Nice to see you.",
};
